import axios from 'axios';

export interface Agente {
  id: string;
  tenant_id: string;
  nome: string;
  papel: string;
  especialidade?: string;
  /** `sistema` são os agentes base do produto: não podem ser redefinidos nem excluídos. */
  origem: 'sistema' | 'custom';
  bairro?: string;
  ativo: boolean;
  ordem: number;
  created_at: string;
  updated_at: string;
}

export type TipoFonte =
  | 'pesquisa'
  | 'noticia'
  | 'relatorio_publico'
  | 'discurso'
  | 'documento_interno';

export interface Fonte {
  id: string;
  tenant_id: string;
  nome: string;
  tipo: TipoFonte;
  ano?: number;
  escopo?: string;
  cargo?: string;
  resumo?: string;
  uso?: string;
  url?: string;
  processada: boolean;
  created_at: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const agentesApi = {
  list: async (token: string) => {
    const res = await axios.get<Agente[]>(`${API_URL}/oto/agentes`, auth(token));
    return res.data;
  },
  create: async (data: Partial<Agente>, token: string) => {
    const res = await axios.post<Agente>(`${API_URL}/oto/agentes`, data, auth(token));
    return res.data;
  },
  update: async (id: string, data: Partial<Agente>, token: string) => {
    const res = await axios.put<Agente>(`${API_URL}/oto/agentes/${id}`, data, auth(token));
    return res.data;
  },
  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/oto/agentes/${id}`, auth(token));
  },
};

export const fontesApi = {
  list: async (token: string, filtros?: { escopo?: string; tipo?: string }) => {
    const res = await axios.get<Fonte[]>(`${API_URL}/oto/fontes`, {
      ...auth(token),
      params: filtros,
    });
    return res.data;
  },
  create: async (data: Partial<Fonte>, token: string) => {
    const res = await axios.post<Fonte>(`${API_URL}/oto/fontes`, data, auth(token));
    return res.data;
  },
  update: async (id: string, data: Partial<Fonte>, token: string) => {
    const res = await axios.put<Fonte>(`${API_URL}/oto/fontes/${id}`, data, auth(token));
    return res.data;
  },
  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/oto/fontes/${id}`, auth(token));
  },
};
